// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1101":"e2691a61","3910":"70c9df67"}[chunkId] + ".chunk.css";
};